import { required, Create, SimpleForm, ImageField, TextInput, SelectInput, FileField } from 'react-admin';
import { useWatch } from 'react-hook-form';
import FileInputAdsCustom from '../FileInputAdsCustom.styles';
import { CustomToolbar } from '../../../utils';
import { adLabel, upperTrimString } from "../../../normalize";
import TYPE_CONTENT_ENUM from "../enums/type-content-enum";
import CustomFileInput from '../../../components/CustomFileInput';
import { useNotify } from 'react-admin';
const validateRequired = required();
const selectStyle = { width: "230px", minWidth: "230px" };

const ContentTypeInput = () => {
  const tipoConteudo = useWatch({ name: 'typeContent.id' });
  const notify = useNotify();
  if (tipoConteudo === TYPE_CONTENT_ENUM.URL) {
    return (
      <TextInput label="URL" source="url" validate={validateRequired} resettable />
    );
  }
  if (tipoConteudo === TYPE_CONTENT_ENUM.FILE) {
    return (
      <FileInputAdsCustom>
      <CustomFileInput
        source="urlFile"
        label="Arquivo"
        accept="application/pdf,image/jpeg,image/png"
        validate={validateRequired}
        uploadText="Arraste um arquivo para upload ou clique para selecionar"
        formatText="Formato aceito: PDF, JPG, PNG"
        options={{
          onDropRejected: () => notify("Arquivo inválido. Apenas arquivos PDF, JPG e PNG são aceitos.", { type: "error" })
        }}
      >
        <FileField source="src" title="title" />
      </CustomFileInput>
      </FileInputAdsCustom>
    );
  }
  return null;
};

const AdCreate = (props) => {
  const notify = useNotify();
  return (
  <Create redirect='list' title="Novo Anúncio" {...props}>
    <SimpleForm toolbar={<CustomToolbar />}>
      <TextInput label="Título" source="title" validate={validateRequired} resettable />
      <TextInput label="Descrição" source="description" validate={validateRequired} resettable />
      <TextInput label="Ciclo" source="cycle[0].id" validate={validateRequired} resettable normalize={upperTrimString} />
      <TextInput placeholder="Limite: 20 caracteres" label="Botão Personalizado" source="label" normalize={adLabel} resettable />
      <SelectInput 
        label="Tipo de Conteúdo"
        style={selectStyle}
        source="typeContent.id"
        validate={validateRequired}
        choices={[
          { id: TYPE_CONTENT_ENUM.URL, name: 'URL' },
          { id: TYPE_CONTENT_ENUM.FILE, name: 'Upload de Arquivo' }
        ]}
      />
      <ContentTypeInput />
      <FileInputAdsCustom>
        <CustomFileInput 
          source="icon" 
          label="Imagem" 
          accept="image/*" 
          validate={validateRequired}
          uploadText="Arraste uma imagem para upload ou clique para selecionar"
          formatText="Formato aceito: JPG, PNG"
          options={{
            onDropRejected: () => notify("Arquivo inválido. Apenas arquivos JPG e PNG são aceitos.", { type: "error" })
          }}
        >
          <ImageField source="src" title="title" validate={validateRequired} />
        </CustomFileInput>
      </FileInputAdsCustom>
    </SimpleForm>
  </Create>
  );
};

export default AdCreate;
